import React, { useMemo } from 'react';
import { Tooltip } from '@usepepper/ui/atoms/tooltip';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

interface OrderEntryTableDescriptionCellProps {
  text: string;
}

const MAX_TOOLTIP_WIDTH = 300;
const MAX_TOOLTIP_CHARACTERS = 350;

export const OrderEntryTableTooltipTextCell: React.FC<
  OrderEntryTableDescriptionCellProps
> = ({ text }) => {
  const theme = useTheme();
  const tooltipText = useMemo(() => {
    return text.length > MAX_TOOLTIP_CHARACTERS
      ? `${text.slice(0, MAX_TOOLTIP_CHARACTERS)} ...`
      : text;
  }, [text]);

  return (
    <Tooltip
      containerStyle={{ maxWidth: MAX_TOOLTIP_WIDTH }}
      placement="top right"
      tabIndex={-1}
      trigger={
        <Typography
          color={theme.sk.color.text.primary}
          numberOfLines={2}
          variant="paragraph-md"
        >
          {text}
        </Typography>
      }
    >
      <Typography color={theme.sk.color.text.primary} variant="paragraph-md">
        {tooltipText}
      </Typography>
    </Tooltip>
  );
};
